// STEP LIVE-STUDIO-CONSOLE-SPLIT-1 · 채널 연결 전용 route.
//
// 목적: BroadcastSelector 의 `플랫폼 연결상태 확인` 이 지금은 /seller/live-control
// (PC Studio 전체) 로 가면서 Camera/Mic/상품/Overlay 등 운영 UI 가 전부 열린다.
// 이 route 는 **채널 연결 상태 / 계정 정보 / 연결·재연결·연결 해제** 만 노출.
//
// REUSE:
//   · LiveChannelsCard (components/seller/live/LiveChannelsCard.js) 를 full-mode 로 호스팅.
//   · 기존 OAuth action/endpoint (`GET /api/youtube/oauth/start`, 각 플랫폼 connect/
//     disconnect) 은 전부 LiveChannelsCard 내부가 이미 호출.
//
// 금지 (STEP §2):
//   · Camera / Mic / LIVE 영상 / 상품 / Overlay / 댓글 / 주문 / 재고 UI 노출 금지.
//   · OAuth backend 수정 금지.
//   · 신규 collection / state / endpoint 생성 금지.
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Radio } from 'lucide-react';
import LiveChannelsCard from '@/components/seller/live/LiveChannelsCard';

const SellerChannels = () => {
  return (
    <div className="min-h-[100dvh] bg-white dark:bg-[#0A0A0A] text-black dark:text-white"
          data-testid="seller-channels-page">
      <div className="max-w-xl mx-auto px-4 py-6">
        <Link to="/seller/dashboard?section=broadcasts"
              className="text-xs text-gray-500 hover:text-[#FF3B30] inline-flex items-center gap-1 mb-4"
              data-testid="seller-channels-back">
          <ArrowLeft size={12} /> 방송 관리로 돌아가기
        </Link>

        <h1 className="text-2xl font-black mb-1 inline-flex items-center gap-2">
          <Radio size={20} className="text-[#FF3B30]" /> 채널 연결
        </h1>
        <p className="text-xs text-gray-500 mb-5">
          YouTube · TikTok · Instagram 계정 연결 상태를 확인하고 재연결하세요.
          <br />이 화면은 채널 관리 전용 · Camera / Mic / 상품 / Overlay 는 LIVE Studio 에서 조작합니다.
        </p>

        {/* LiveChannelsCard 를 full mode 로 (compact=false). 내부 OAuth connect /
            재연결 / disconnect 액션 전부 REUSE. */}
        <LiveChannelsCard compact={false} />
      </div>
    </div>
  );
};

export default SellerChannels;
